import config from '../config';

const isLocal = () => {
  // React Native doesn't have window.location - only web does
  // Must check existence before accessing to prevent crashes in error handler
  if (typeof window === 'undefined' || !window.location || !window.location.origin) {
    return false; // Not running on web, can't be "local" in browser sense
  }

  const localOrigins = ['192.168', 'localhost', '127.0.0.1'];
  return localOrigins.some(origin => window.location.origin.includes(origin));
};

const isDev = () => config.ENV === 'DEV';
const isBeta = () => config.ENV === 'BETA';

export default {
  isLocal,
  isDev,
  isBeta,
  enableDebugging: () => isLocal() || isDev() || isBeta(),
};
